import { PaginationParams } from '@/shared/types';
import { DateRange } from 'react-day-picker';

export abstract class CompanyKeys {
  static ALL = ['companies'];
  static PAGED = (pagination: PaginationParams) => [
    ...CompanyKeys.ALL,
    pagination,
  ];
  static BY_ID = (companyId: number) => [
    ...CompanyKeys.ALL,
    'by-id',
    companyId,
  ];
  static BY_ORGANIZATION = (organizationId?: number) => [
    ...CompanyKeys.ALL,
    'by-organization',
    organizationId,
  ];
  static BY_ORGANIZATION_PAGED = (
    organizationId: number,
    pagination: PaginationParams,
  ) => [...CompanyKeys.BY_ORGANIZATION(organizationId), pagination];
  static BY_USER = (userId: number) => [...CompanyKeys.ALL, 'by-user', userId];
  static BY_USER_PAGED = (userId: number, pagination: PaginationParams) => [
    ...CompanyKeys.BY_USER(userId),
    pagination,
  ];
  static BY_INFRASTRUCTURE_COST = (infrastructureCostId: number) => [
    ...CompanyKeys.ALL,
    'by-infrastructure-cost',
    infrastructureCostId,
  ];
  static BY_INFRASTRUCTURE_COST_PAGED = (
    infrastructureCostId: number,
    pagination: PaginationParams,
  ) => [
    ...CompanyKeys.BY_INFRASTRUCTURE_COST(infrastructureCostId),
    pagination,
  ];

  static ELIGIBLE_BY_INFRASTRUCTURE_COST = (infrastructureCostId?: number) => [
    ...CompanyKeys.ALL,
    'eligible-by-infrastructure-cost',
    infrastructureCostId,
  ];

  static AUTOMATIONS_PERFORMANCE = (
    companyId: number,
    dateRange?: DateRange,
    filter?: string,
  ) => [
    ...CompanyKeys.BY_ID(companyId),
    'automations-performance',
    dateRange,
    filter,
  ];

  static LABOUR_AUTOMATED = (
    companyId: number,
    dateRange?: DateRange,
    filter?: string,
  ) => [...CompanyKeys.BY_ID(companyId), 'labour-automated', dateRange, filter];

  static TOTAL_RETURN = (
    companyId: number,
    dateRange?: DateRange,
    filter?: string,
  ) => [...CompanyKeys.BY_ID(companyId), 'total-return', dateRange, filter];

  static PROFILE_PICTURE = (companyId: number) => [
    ...CompanyKeys.BY_ID(companyId),
    'profile-picture',
  ];
}
